import { dataMagicWandSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMagicWandSolid = /*#__PURE__*/createIcon(dataMagicWandSolid)
export default IconMagicWandSolid
